import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { useReportingApi } from '../../../api'
import { fetchQueues } from '../api/queueApi'
import type { CallQueue } from '../types'

export const queueQueryKeys = {
  all: ['queues'] as const,
  list: (pbxId: number) => [...queueQueryKeys.all, pbxId] as const,
}

export interface UseQueuesOptions {
  pbxId: number
  options?: Omit<UseQueryOptions<CallQueue[], Error>, 'queryKey' | 'queryFn'>
}

export const useQueues = ({ pbxId, options = {} }: UseQueuesOptions) => {
  const api = useReportingApi()

  return useQuery<CallQueue[], Error>({
    queryKey: queueQueryKeys.list(pbxId),
    queryFn: async ({ signal }) => fetchQueues(api, pbxId, signal),
    enabled: options.enabled !== undefined ? options.enabled : !!pbxId,
    retry: 1,
    ...options,
  })
}

export default useQueues
